import { PortfolioCategories } from '@/types/models';

export enum EOrderType {
  PRODUCT = 'product',
  PORTFOLIO = 'portfolio'
}

export enum EProductType {
  Funds = 'funds',
  Bond = 'fixed-income',
  GovernmentBond = 'government-bond',
  FundPension = 'fund-pension',
  StructuredOperation = 'structured-operation',
  InitialPublicOffering = 'initial-public-offering'
}

export enum EButtonAction {
  OPEN_ORDER = 'open_order'
}

export interface IPendingOrder {
  title: string;
  products: IProduct[];
}

export interface IProduct {
  title: string;
  orders: IOrder[];
}

export interface IOrder {
  description: string;
  icon: string;
  id: string;
  orderType: EOrderType;
  productType: EProductType | null;
  portfolioType: PortfolioCategories | null;
  status: string;
  title: string;
  value: string;
}

export interface IProductOrderDetails {
  apiId: string;
  productId: string;
  productType: string;
  heading: {
    head: string;
    title: string;
    subtitle: {
      text: string;
      color: string;
    };
  };
  details: {
    list: {
      label: string;
      value: string;
    }[];
    status: {
      title: string;
      description: string;
      icon: string;
      color: string;
    } | null;
    footer: {
      button: string;
    } | null;
  };
}

export interface IPortfolioOrderDetails {
  portfolioId: string;
  head: string;
  title: string;
  subtitle: string;
  list: {
    label: string;
    value: string;
  }[];
  message: {
    title: string;
    description: string;
    icon: string;
  } | null;
  button: {
    label: string;
    action: EButtonAction;
  };
}

export interface ICancelOrder {
  orderId: string;
  title?: string;
}
